import React from 'react';
export default function PlaybackMode({ mode, onMode, settings, status }) {
  if (!settings?.available || !settings?.enabled) return null;
  if (settings.requiresViewerToken) return <div role="status" style={{ color: '#f9b000', font: '12px var(--font-mono, monospace)' }}>
    LIVE · broadcast sync ({status})
  </div>;
  return <div role="group" aria-label="Live data mode" style={{ display: 'flex', gap: 8, alignItems: 'center',
    color: '#e5e5e5', font: '12px var(--font-mono, monospace)', padding: '9px 0' }}>
    <button type="button" aria-pressed={mode === 'live'} onClick={() => onMode('live')}>Live data</button>
    <button type="button" aria-pressed={mode === 'pub'} onClick={() => onMode('pub')}>Match pub TV</button>
    <span role="status">{mode === 'pub' ? `TV sync · ${status}` : 'Live data may be ahead of the TV'}</span>
  </div>;
}
